import {
    call,
    put,
    select,
} from 'redux-saga/effects'
import PopupQueue from 'common/modules/popupQueue'

import { clear } from '../actions'

const clearCreators = clear.creators()

function* clearPopupsProcessor() {
    try {
        let remainingPopups = yield select(PopupQueue.length)

        while (remainingPopups > 0) {
            yield put(
                yield call(
                    PopupQueue.remove,
                ),
            )
            remainingPopups = yield select(PopupQueue.length)
        }

        yield put(
            yield call(
                clearCreators.clearSuccess,
            ),
        )
    } catch (error) {
        yield put(
            yield call(
                clearCreators.clearError,
                {
                    error,
                },
            ),
        )
    }
}

export default clearPopupsProcessor
